import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  paragraph: {
    width: '85%',
    margin: 'auto',
  },
  aboutus: {
    color: '#2F5EA8',
    fontSize: '24px', 
    fontWeight: 'bold'
  }
}));

const AboutUs = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h4" gutterBottom className={classes.aboutus}>
        ABOUT US
      </Typography>
      <Typography variant="body1" className={classes.paragraph}>
      The Town and Country Planning was created as a small cell in Uttar Pradesh, Public Works Department in the year 1964. During 1979, it was created as in independent Directorate headed by Chief Engineer of Uttar Pradesh Public Works Department till 1993 when independent Director was appointed as Head of Department.
      </Typography>
    </div>
  );
};

export default AboutUs;
